import { MEDIA_QUERY } from '../enums';
import { breakpoints } from './sc-vars';

/**
 * How to use:
 * import { styled } from '@/styles/styled'
 * import media from 'path-to-media-file'
 *  const StyledComponent = styled.div`
 *    display: none;
 *     ${media.mobileLandscape} {
 *       display: block;
 *     }`
 */

const customMediaQuery = (breakpoint: number, mediaQuery: MEDIA_QUERY = MEDIA_QUERY.MIN_WIDTH) => {
  return `(${mediaQuery} ${breakpoint}px)`;
};

const { sm, md } = breakpoints;

/**
 * We should try to have as few media queries as possible in terms of maintainability of the responsive design
 * Let's try to do as much as possible with flex boxes
 */

export const media = {
  ie11: ` @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none)`,
  mobileLandscape: `@media ${customMediaQuery(md, MEDIA_QUERY.MAX_HEIGHT)} and (orientation: landscape)`,
  mobilePortrait: `@media ${customMediaQuery(md, MEDIA_QUERY.MAX_WIDTH)} and (orientation: portrait)`,
  mobilePortraitXS: `@media ${customMediaQuery(sm, MEDIA_QUERY.MAX_WIDTH)}`, // Extra small devices (phones, 600px and down)
};

export type MediaType = keyof typeof media;
